export default __webpack_public_path__ + "static/media/empty_xct9.a0b66bd5.svg";